<template>

    <question-base :required="answerRequired"
                   :next-button-text="translations.nextButtonText"
                   :back-button-text="translations.backButtonText"
                   :back-button-enabled="backButtonEnabled"
                   :skip-button-text="translations.skipButtonText"
                   @skip="skipClicked"
                   @next="nextClicked"
                   @back="backClicked"
                   :background-color="backgroundColor"
                   :button-color="buttonColor"
                   :saving="loading">

        <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

            <validation-provider
                    :name="variable.name"
                    :rules="Object.assign({numeric:true},rules)"
                    mode="eager"
                    v-slot="{ errors }">

                <question-header :question-text="questionText"
                                 :button-color="buttonColor"
                                 :background-color="backgroundColor"
                ></question-header>

                <v-text-field
                        v-model="model"
                        solo
                        class="pt-4"
                        :placeholder="translations.survey_please_enter_your_answer_here"
                        :counter="counterSize"
                        :error-messages="errors"
                        type="number"
                        :dark="isDarkColor(backgroundColor)"
                        @keydown.enter="nextClicked"
                ></v-text-field>

            </validation-provider>

        </validation-observer>
    </question-base>
</template>

<script>

    import questionMixin from "./questionMixin";
    import QuestionHeader from "./QuestionHeader";
    import QuestionBase from "./QuestionBase";
    import colorMixin from "./colorMixin";

    export default {

        mixins: [questionMixin, colorMixin],

        components: {
            QuestionHeader,
            QuestionBase
        },

        props: {

            value: {
                type: Number | null,
                required: false,
                default: null
            }
        },
    }
</script>
